import { ChainConfig } from '../types';

// Dynamic import of all character PNGs
const characterImages = import.meta.glob<{ default: string }>('../assets/characters/*.png', { eager: true });

// Convert the imported modules to an array of image URLs
export const CHARACTER_IMAGES = Object.values(characterImages).map(module => module.default);

const hyperliquidMainnet: ChainConfig = {
  id: 999,
  name: 'Hyperliquid',
  nativeCurrency: { name: 'HyperEVM', symbol: 'HYPE', decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        // 'https://rpc.hyperliquid.xyz/evm'
        'https://rpc.hyperlend.finance'
        ],
    },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://hyperliquid.cloud.blockscout.com/',
      apiUrl: 'https://hyperliquid.cloud.blockscout.com/',
    },
  },
  contracts: {
    purrtardioCa: {
      address: import.meta.env.VITE_PURRTARDIO_CA_ADDRESS || '0x0000000000000000000000000000000000000000',
    },
    stakingContract: {
      address: import.meta.env.VITE_STAKING_CONTRACT_ADDRESS || '0x0000000000000000000000000000000000000000',
    },
    tokenContract: {
      address: import.meta.env.VITE_TOKEN_CONTRACT_ADDRESS || '0x0000000000000000000000000000000000000000',
    }
  },
};

const hyperliquidTestnet: ChainConfig = {
  id: 998,
  name: 'HyperEVM Testnet',
  nativeCurrency: { name: 'HyperEVM Testnet', symbol: 'HYPE', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.hyperliquid-testnet.xyz/evm'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://evm.hyperstats.xyz/',
      apiUrl: 'https://evm.hyperstats.xyz/',
    },
  },
  contracts: {
    purrtardioCa: {
    "address": "0xdd60A06852345f146E0Cf3D11ffAd6b9Fe2f1566"
    },
    stakingContract: {
      address: "0x21B34b10bA2daA016e2eD9867a79DDB72032a7f4" // staking contract on testnet
    },
    tokenContract: {
      address: "0xa9056c15938f9aff34cd497c722ce33db0c2fd57" // PURR on testnet
    }  
  },
};

export const hyperliquidLocalhost: ChainConfig = {
  id: 1337,
  name: "localhost",
  nativeCurrency: { name: "HyperEVM", symbol: "HYPE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["http://localhost:8545"],
    },
  },
  contracts: {
    purrtardioCa: {
      address: "0x5FbDB2315678afecb367f032d93F642f64180aa3"
    },
    stakingContract: {
      address: import.meta.env.VITE_STAKING_CONTRACT_ADDRESS || '0x0000000000000000000000000000000000000000',
    },
    tokenContract: {
      address: import.meta.env.VITE_TOKEN_CONTRACT_ADDRESS || '0x0000000000000000000000000000000000000000',
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "http://localhost:8545",
      apiUrl: "http://localhost:8545",
    }
  }
};


const getHyperliquidEvmConfig = () => {
  const isMainnet = import.meta.env.VITE_ENVIRONMENT === 'mainnet'
  const isTestnet = import.meta.env.VITE_ENVIRONMENT === 'testnet'
  const isLocal = import.meta.env.VITE_ENVIRONMENT === 'local'

  if (isMainnet) return hyperliquidMainnet
  if (isTestnet) return hyperliquidTestnet
  if (isLocal) return hyperliquidLocalhost

  return hyperliquidMainnet
}

export const hyperliquidEvmConfig = getHyperliquidEvmConfig()


export const CHAT_MESSAGES = [
  "Meow! Ready to join the party?",
  "Purr-fect day for minting!",
  "You're looking pawsome!",
  "Let's make history together!",
  "Time to get your paws on some NFTs!",
  "This collection is going to be legendary!",
  "Don't wait, mint meow!",
  "Feline creative today?",
  "You've cat to be kitten me with these amazing NFTs!",
  "Paw-don me, but these NFTs are incredible!",
  "Having a purr-ticular good day in the NFT space!",
  "Whisker you away to NFT paradise!",
  "Are you kitten me? These NFTs are amazing!",
  "I'm not lion, these are some great pieces!",
  "Your collection is the cat's meow!",
  "Feeling claw-some with these new drops!",
  "Hiss-tory in the making right here!",
  "Purrtardio: where the cool cats mint!",
  "Let's pounce on these opportunities!",
  "Don't be a scaredy-cat, mint today!",
  "You're absolutely purr-fect for this community!",
  "Meow-velous choices in your collection!",
  "Are you feline lucky today?",
  "Cat-ch these NFTs while they're hot!",
  "Your NFT game is looking purr-ty good!",
  "That's the purr-fect addition to your collection!",
  "Stop paws-ing and start minting!",
  "You're the cat's whiskers in the NFT world!",
  "Fur-real, these NFTs are amazing!",
  "Let's not pussyfoot around - these NFTs are fire!",
  "You've got to be kitten me with that awesome mint!",
  "Meow-nificent choice of NFTs!",
  "Looking quite fur-midable with that collection!",
  "Kitty got your wallet? Time to mint!",
  "Purrtardio: where NFTs are always purr-fect!",
  "That's one fur-bulous NFT you've got there!",
  "We're not kitten around with these drops!",
  "Purr-haps today is your lucky minting day!",
  "Cat-ching everyone's attention with your collection!",
  "Tail me more about your NFT strategy!",
  "Feline like sharing your latest mint?",
  "Paw-sitively incredible NFT choices!",
  "You're making me purr with excitement!",
  "What a cat-ch! That NFT is amazing!",
  "Meow-nt to tell you how great your collection is!",
  "Are you fur-real with that awesome NFT?",
  "Purrtardio: where every NFT is the cat's pajamas!",
  "Looking fur-ward to your next mint!",
  "You're cat-apulting to the top with these NFTs!",
  "That's a meow-numental addition to your collection!",
  "Fur-get about the rest, your NFTs are the best!",
  "Purrtardio is hiss-torically the best place to mint!",
  "You've got to be kitten me with that talent!",
  "Paws-itively thrilled about your new NFT!",
  "Cat's out of the bag - these NFTs are fire!",
  "Fur-tunately, you found Purrtardio!",
  "Whisker me away with these amazing NFTs!",
  "You're the cat's meow in the NFT world!",
  "I'm feline good about your collection!",
  "Purr-suasive choices in your NFT strategy!",
  "Litter-ally the best NFTs I've seen today!",
  "Are you kitten me? That's an amazing mint!",
  "Cat-ching my breath after seeing your collection!",
  "Paw-lease tell me where you found that NFT!",
  "You're a-meow-zing at curating NFTs!",
  "That's a purr-ty impressive collection you've got!",
  "Fur-real, you've got an eye for good NFTs!",
  "Meow's the time to expand your collection!",
  "Stop being so paw-some at collecting NFTs!",
  "Purrtardio: where every day is Catur-day!",
  "Paw-don the interruption, but nice NFTs!",
  "That's cat-tastic minting technique!",
  "Purr-haps you should mint another one?",
  "You make this NFT thing look easy - not kitten!",
  "Paw-sibly the best collection on Purrtardio!",
  "Paw-lease share your NFT wisdom!",
  "I'm feline a connection with your artistic taste!",
  "Hiss-terical how good your NFTs are!",
  "Purr-suing the best NFTs, I see!",
  "Meow about showing off your latest mint?",
  "Cat-egorically the best NFT I've seen today!",
  "You're making a hiss-tory with these choices!",
  "Fur-tunate to have you in our community!",
  "That's pawsitively remarkable minting!",
  "Claw-ver choice adding that to your collection!",
  "You're kitten it out of the park with these NFTs!",
  "Purrtardio: where NFTs are always the cat's meow!",
  "Feline fine about your latest additions!",
  "That's a purr-fectly executed mint!",
  "Fur-get what others are doing, your collection rocks!",
  "Whisker all your NFT secrets!",
  "You've cat to be kitten me with that amazing NFT!",
  "Purr-haps it's time for another mint?",
  "Feline like today's a good day for some new NFTs?",
  "Purrtardio: where every NFT is paws-itively amazing!",
  "You've got to be kitten me with that talent!",
  "That's a meow-nificent addition to your collection!",
  "Purr-ty impressive NFT strategy you've got there!",
  "Meow is the time for great NFTs!"
];

export const EMPTY_STATE_MESSAGES = [
  "Nyaa~ Your collection looks empty! Time to mint some purr-fect NFTs!",
  "Hey there! Ready to start your Purrtardio journey?",
  "The party's just getting started! Mint your first NFT!",
  "Your future NFTs are waiting to be discovered!",
  "Feline a bit lonely here! Let's add some paw-some NFTs!",
  "Your collection is looking cat-astrophically empty! Let's fix that!",
  "Meow's the time to start your collection!",
  "This space is purr-fectly ready for your first NFT!",
  "Don't be a scaredy-cat! Jump into the NFT world!",
  "Whisker you waiting for? Start your collection today!",
  "Your Purrtardio gallery is looking a little hiss-torical without any NFTs!",
  "Pawsitively excited for you to add your first NFT!",
  "Fur-get waiting around - mint some amazing NFTs now!",
  "Your collection has potential to be the cat's meow!",
  "This empty space is giving me cat-titude! Time to mint!",
  "Looking for the purr-fect first NFT? Start minting!",
  "Claw-ver collectors start with just one NFT!",
  "Feline creative? Express yourself with your first NFT!",
  "This gallery is waiting for a purr-sonal touch!",
  "Let's not paws any longer - add some NFTs to your collection!",
  "Your Purrtardio shelf is looking quite fur-lorn without NFTs!",
  "Cat got your cursor? Click that mint button!",
  "This empty space is making me fur-ious with anticipation!",
  "Tabby or not tabby? The answer is always: mint more NFTs!",
  "Your collection needs a lit-purr upgrade!",
  "Feeling claw-some today? Show it with your first NFT!",
  "This empty space is giving me the meow-nchies for some NFTs!",
  "Your Purrtardio journey is just a whisker away from starting!",
  "Kitten around? No way! Time to get serious about your collection!",
  "Feeling like the cat's pajamas? Share it with a new NFT!",
  "This gallery is purr-petually ready for your creative expression!",
  "Stop cat-napping and start your collection today!",
  "Your Purrtardio page is looking a bit cat-atonic without NFTs!",
  "We're not kitten around - your first NFT will be amazing!",
  "This space is the cat's whiskers - just missing your NFTs!",
  "Mew-velous things happen when you start your collection!",
  "Are you feline it? Time to mint your first NFT!",
  "Your Purrtardio collection: currently on paws, ready to play!",
  "Stop lion around and add some NFTs to your collection!",
  "This empty space is giving me a serious case of the mews!",
  "Purr-haps today is the day to start your NFT adventure!",
  "Empty shelves? You've got to be kitten me!",
  "Your collection is looking paw-sitively barren!",
  "Time to stop procats-tinating and mint your first NFT!",
  "This space is meow-nificent - just add NFTs!",
  "Fur real? Still no NFTs? Let's change that!",
  "Your Purrtardio page is in a cat-atonic state without some NFTs!",
  "Feeling paw-some today? Express it with your first NFT!",
  "Claw your way to an impressive collection starting now!",
  "This gallery's purr-pose is to showcase your NFTs!",
  "Calling all cool cats - your collection awaits!",
  "Are you feline lucky? Mint your first NFT!",
  "Your empty collection has me purr-plexed!",
  "Whis-purr it with me: 'Time to mint my first NFT!'",
  "Litter-ally the perfect time to start collecting!",
  "This empty space is giving me the cat-terwauls!",
  "Fur-tunately, adding your first NFT is easy!",
  "Paws what you're doing and mint your first NFT!",
  "Your collection is looking rather im-paw-verished!",
  "Meow's the moment to make your mark in the NFT world!"
];

// Staking-related constants
export const STAKING = {
  TOKEN_SYMBOL: 'PURR',
  TOKEN_NAME: 'Purrtardio Token',
  TOKEN_DECIMALS: 18,
  MIN_STAKE_AMOUNT: '1000000000000000000', // 1 token with 18 decimals
  DEFAULT_APPROVAL_AMOUNT: '115792089237316195423570985008687907853269984665640564039457584007913129639935', // Max uint256 for unlimited approval
};